/** @format */

import { ReactNode, useContext } from "react";
import { Link } from "react-router-dom";
import { Context } from "../../../stores/Provider";

const LinkByAgent = ({
  children,
  to,
  confirm_flag,
  accordionNum,
  from,
}: {
  children: ReactNode;
  to: string;
  confirm_flag?: boolean;
  accordionNum?: number;
  from?: string;
}) => {
  const { state } = useContext(Context);
  return (
    <Link
      to={state.agentPath + to}
      state={{
        routeTo: state.agentPath + to,
        confirm_flag: confirm_flag,
        accordionNum: accordionNum,
        from: from,
      }}
    >
      {children}
    </Link>
  );
};

export default LinkByAgent;
